/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-folder-users-grid .inherited-checkbox-outer-container{position:relative;z-index:1}ui-folder-users-grid .inherited-checkbox-outer-container .inherited-checkbox-outer-container{position:absolute;top:18px;left:180px}"];
export { styles as styles };
